<template>
    <div>
        <UiBreadcrumbs v-editable="blok" :blok="blok" />
    </div>
</template>

<script lang="ts" setup>
import type { IBreadcrumbsConfig } from '@nuxt-monorepo/ui/types';

defineProps<{
    blok: IBreadcrumbsConfig;
}>();
</script>

<style lang="postcss" scoped>
:deep(.breadcrumbs) {
    @apply text-white font-semibold text-[15px] px-0.5;
    .parent-link {
        @apply text-secondary transition-all;
        &:hover {
            @apply text-white;
        }
    }
    .breadcrumbs-container {
        @apply flex-wrap;
    }
    .breadcrumbs-item {
        @apply inline-flex items-center;
    }
}
</style>
